import React from 'react';
import { ProperBetMainLogoWrapper, ProperBetMainLogo } from './properbet.style';

export const ProperBetLogotype = (): JSX.Element => (
    <ProperBetMainLogoWrapper>
        <ProperBetMainLogo />
    </ProperBetMainLogoWrapper>
);
